import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';

export const useBrandRegistry = () => {
  return useQuery({
    queryKey: ['brand-registry'],
    queryFn: () => apiService.getBrandRegistry(true),
    staleTime: 5 * 60 * 1000,
  });
};
